import type { CommandHandler } from '../types';

export const configureAiProviderCommandHandler: CommandHandler = (_command, context) => {
  if (!context.openConfigureAiProviderDialog) {
    return { success: false, error: 'AI provider settings are not available on this page.' };
  }

  context.openConfigureAiProviderDialog();
  return { success: true };
};
